import { Component, Input } from '@angular/core';
import {
  selectRulesLoading,
  selectRulesError,
} from '../../../store/selectors/rules.selector';
import { Store } from '@ngrx/store';
import { mapErrorMessage } from '../../../../utils/error.utils';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.scss',
  standalone: false,
})
export class ErrorMessageComponent {
  @Input() lastErrorMessage: string | undefined = undefined;
  @Input() lastErrorType: string | undefined = undefined;

  constructor(private store: Store) {}
  loading$ = this.store.select(selectRulesLoading);
  error$ = this.store.select(selectRulesError);

  get translatedErrorMessage(): string {
    return mapErrorMessage(this.lastErrorType ?? this.lastErrorMessage ?? '');
  }
}
